export const SET_POPUP_LIST = "announcements/SET_POPUP_LIST";
export const SET_VIDEO_LIST = "announcements/SET_VIDEO_LIST";